import { MessageCardProps } from "declarations/messages";
import { getTime } from "functions/text";
import React from "react";

function SentMessageCard({ message, onDeleteRequest, onRetry, onListingPress }: MessageCardProps) {

  const failed = message.status === "failed";
  const messageStatus =
    message.status === "sending"
      ? "Sending..."
      : message.status === "failed"
      ? "Failed"
      : getTime(message.timestamp || message.createdAt);

  return (
    <div className={ClassName.container}>
      <div
        className={`${ClassName.message} ${failed ? ClassName.failedMessage : ""}`}
        onContextMenu={(event) => {
          if (!onDeleteRequest || message.status === "sending") return;
          event.preventDefault();
          onDeleteRequest(message);
        }}
      >
        <div className={ClassName.content}>
          {(message.carTitle || message.car) && (
            <button
              type="button"
              className={ClassName.tag}
              onClick={() => onListingPress?.(message)}
            >
              {message.carTitle || "View listing"}
            </button>
          )}
          <span className={ClassName.text}>{message.text}</span>
        </div>
        {failed && onRetry ? (
          <button
            type="button"
            className={ClassName.retry}
            onClick={() => onRetry(message)}
          >
            Failed - Retry
          </button>
        ) : (
          <span className={ClassName.meta}>{messageStatus}</span>
        )}
      </div>
    </div>
  );
}

export default SentMessageCard;

const ClassName = {
  container: "flex flex-col w-full my-0.5 items-end",
  message:
    "text-[13px] bg-slate-800 text-white w-fit max-w-[72%] px-4 py-2.5 rounded-2xl rounded-tr-none flex items-end gap-3 shadow-sm border border-slate-700",
  failedMessage: "border-primary/80",
  content: "flex flex-col gap-1 min-w-0",
  text: "break-words whitespace-pre-wrap leading-5",
  meta: "text-[10px] text-white/50 flex-shrink-0 whitespace-nowrap",
  retry: "text-[10px] font-semibold text-red-300 whitespace-nowrap",
  tag: "text-white/80 font-semibold underline underline-offset-2 cursor-pointer bg-transparent border-0 p-0 text-left",
};
